import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectMeteorologyAgroCultureIndexLocationCulture, setCulture as setCultureRedux } from 'redux/reducers/meteorologyAgroCultureIndexLocationReducer';
import { store } from 'redux/store';
import { CultureIndexCulture } from 'types/Meteorology/Agro/CultureIndex/culture';
import useCulture from '../useCulture';

export default function useCultures() {
  const { cultures } = useCulture();

  const setCulture = useCallback((culture: CultureIndexCulture | undefined) => {
    store.dispatch(setCultureRedux(culture));
  }, []);

  const selectedCulture = useSelector(selectMeteorologyAgroCultureIndexLocationCulture);

  return {
    cultures,
    selectedCulture,
    setCulture,
  };
}
